import { useEffect, useState } from "react";
import styles from "./navigation-bar.module.css";
import { MainAppMenu } from "./main-app-menu/main-app-menu";
import { NavigationBarCheckoutButton } from "./navigation-bar-checkout-button";
import { usePaths } from "BEDROCK/paths";
import { useCheckout } from "BEDROCK/pages/checkout/checkout-provider";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { useProjectStore } from "entity-store/project-store/use-project-store";
import { PosterProject } from "PosterEditor/model/poster-project";
import { useAppScroll } from "use-app-scroll";
import { useAuthContext } from "BEDROCK/auth/auth-provider";
import { useTouchMode } from "BEDROCK/mobile";

interface NavigationBarProps {
  isHidden?: boolean;
}

export const NavigationBar = (props: NavigationBarProps) => {
  const containerClasses = props.isHidden
    ? `${styles.container} ${styles.hidden}`
    : styles.container;

  return (
    <div className={containerClasses}>
      <LeadingContent />
      <TrailingContent />
    </div>
  );
};

const LeadingContent = () => {
  const { scrolled } = useAppScroll();

  const { home, navigateTo, checkout, isOnPage } = usePaths();

  return (
    <div className={styles.leadingContent}>
      <button
        className={styles.logo}
        onClick={() => {
          navigateTo(home);
        }}
      >
        <img src="/logo/LOGO.png" alt="TrailArt logo" />
      </button>
    </div>
  );
};

const TrailingContent = () => {
  const { isUserAuthenticated } = useAuthContext();
  const {
    checkout: checkoutPath,
    navigateTo,
    isOnPage,
    mapEditor,
    checkoutReview,
  } = usePaths();
  const { checkout } = useCheckout();
  const { projects } = useProjectStore();
  const isTouchMode = useTouchMode();

  const [firstNonCheckoutProject, setFirstNonCheckoutProject] = useState<
    PosterProject | undefined
  >();

  useEffect(() => {
    const project = projects?.filter(
      (p) => p.isInCheckout === false && p.isOrdered === false
    )[0];
    setFirstNonCheckoutProject(project);
  }, [projects]);

  const goToCurrentProject = () => {
    let id = firstNonCheckoutProject?.id;
    if (!id) {
      return;
    }
    navigateTo(`/project/${id}`);
  };

  if (isTouchMode) {
    return null;
  }

  return (
    <div className={styles.trailingContent}>
      {firstNonCheckoutProject &&
        isUserAuthenticated &&
        !isOnPage(checkoutPath) &&
        !isOnPage(mapEditor) &&
        !isOnPage(checkoutReview) && (
          <div className={styles.continueProjectButton}>
            <CTAButton
              title="Continue your project"
              onClick={() => goToCurrentProject()}
              iconName="PENCIL"
              iconPosition="RIGHT"
              variant="SECONDARY"
            />
          </div>
        )}
      <NavigationBarCheckoutButton
        numberOfItems={checkout.items.length}
        onClick={() => {
          navigateTo(checkoutPath);
        }}
      />
      <MainAppMenu />
    </div>
  );
};
